// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0f1cf8aa","455":"6bddf618"}[chunkId] + ".chunk.js";
};